import React, { useState, useRef } from 'react';
import { Input } from '@/components/ui/inputs/input';
import { InputSelect } from '@/components/ui/inputs/input-select';
import { useForm, Controller } from 'react-hook-form';
import ToastMe from '@/components/ui/ToastMe';

const DataTableFilter = ({ onChangeFilter }) => {
    const selectRef = useRef(null);
    const {
        register,
        setValue,
        getValues,
        formState: { errors },
        handleSubmit,
        control,
        reset,
    } = useForm({
        defaultValues: {
            name: '',
            email: '',
            phone_no: '',
            status: '',
        },
        mode: 'onSubmit',
    });

    const statusOptionList = [
        { value: 1, label: 'Active' },
        { value: 2, label: 'Inactive' },
    ];

    const convertUndefinedToBlank = (obj) => {
        return Object.fromEntries(Object.entries(obj).map(([key, value]) => [key, value === undefined ? '' : value]));
    };

    const clearSelection = () => {
        if (selectRef.current) {
            selectRef.current.clearValue();
        }
    };

    const formReset = async () => {
        try {
            var formData = getValues();
            for (const key in formData) {
                await setValue(key, '');
            }
            await reset();
            await clearSelection();
            await onChangeFilter('extra_filter', {});
        } catch (error) {
            const errorMsg = error?.message || 'Error resetting filter';
            ToastMe(errorMsg, 'error');
            console.error('[ChefsFilter] Reset error:', error);
        }
    };

    const onSubmit = async (data) => {
        try {
            const filterData = await convertUndefinedToBlank(data);
            await onChangeFilter('extra_filter', filterData);
        } catch (error) {
            const errorMsg = error?.message || 'Error applying filter';
            ToastMe(errorMsg, 'error');
            console.error('[ChefsFilter] Error:', error);
        }
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="p-4 sm:p-5 mb-5">
            <div className="row">
                <div className="col-12 sm:col-6 md:col-4 xl:col-3">
                    <Controller
                        control={control}
                        name="name"
                        render={({ field }) => <Input {...field} size="sm" labelText={'Name'} type="text" id="name" className="db-field-control" labelStyleClassName={'db-field-title after:hidden'} />}
                    />
                </div>
                <div className="col-12 sm:col-6 md:col-4 xl:col-3">
                    <Controller
                        control={control}
                        name="email"
                        render={({ field }) => (
                            <Input {...field} size="sm" labelText={'Email'} type="email" id="email" className="db-field-control" labelStyleClassName={'db-field-title after:hidden'} />
                        )}
                    />
                </div>
                <div className="col-12 sm:col-6 md:col-4 xl:col-3">
                    <Controller
                        control={control}
                        name="phone_no"
                        render={({ field }) => (
                            <Input {...field} size="sm" labelText={'Phone'} type="phone_no" id="phone_no" className="db-field-control" labelStyleClassName={'db-field-title after:hidden'} />
                        )}
                    />
                </div>
                <div className="col-12 sm:col-6 md:col-4 xl:col-3">
                    <Controller
                        control={control}
                        name="status"
                        render={({ field }) => (
                            <InputSelect
                                {...field}
                                ref={selectRef}
                                id={'status'}
                                size="sm"
                                labelStyleClassName={'db-field-title after:hidden'}
                                labelText={'Status'}
                                value={statusOptionList.find((data) => data.value === getValues('status')) || null}
                                onChange={(e) => setValue('status', e)}
                                options={statusOptionList}
                            />
                        )}
                    />
                </div>
                <div className="col-12">
                    <div className="flex flex-wrap gap-3 mt-4">
                        <button type="submit" className="db-btn py-2 text-white bg-primary">
                            <i className="lab lab-search-line lab-font-size-16"></i>
                            <span>Search</span>
                        </button>
                        <button type="button" onClick={formReset} className="db-btn py-2 text-white bg-gray-600">
                            <i className="lab lab-cross-line-2 lab-font-size-22"></i>
                            <span>Clear</span>
                        </button>
                    </div>
                </div>
            </div>
        </form>
    );
};

export default DataTableFilter;
